<template lang="pug">

include ../../../../pug/mixins/index

transition(name='modal-wrapper--transition')
  +b.modal-wrapper(v-if='opened', :class='wrapperClasses')
    +e.bg
    +e.window
      slot(name='modalWindow')
        +b.modal(:class='modalClasses').is-opened
          +e.A.close(href!='', @click.prevent='dismiss()', v-if='dismissible') &times;
          +e.inner
            +e.header(v-if='title || $slots.header')
              slot(name='header')
                +e.title(v-html='title')
            +e.content
              slot

            +e.footer(v-if='$slots.footer')
              slot(name='footer')

</template>

<script>

import { Service } from '@shared/services/base'

const ModalService = Service.extend({
  data() { return  {
    opened: 0,
  } },

  computed: {
    isOpened() {
      return this.opened > 0
    }
  },

  methods: {
    open() {
      this.opened++

      // if (this.opened === 1) {
      //   const body = document.body
      //   let initial = body.getBoundingClientRect().width
      //   body.classList.add('has-modal')

      //   let current = body.getBoundingClientRect().width
      //   body.style.paddingRight = `${current - initial}px`
      // }
    },

    close() {
      this.opened--

      // if (this.opened === 0) {
      //   document.body.classList.remove('has-modal')
      //   document.body.style.paddingRight = 0
      // }
    }
  }
})

const modalService = new ModalService()

export default {
  props: {
    title: { type: String },
    theme: { type: String },
    size: { type: String },
    transition: { type: String, default() { return 'v' } },
    dismissible: { type: Boolean, default: true }
  },

  service: modalService,

  data() {
    return {
      opened: false,
    }
  },

  computed: {
    wrapperClasses() {
      return {
        [`modal-wrapper--theme-${this.theme}`]: !!this.theme,
        [`modal-wrapper--size-${this.size}`]: !!this.size,
        'is-opened': this.opened
      }
    },

    modalClasses() {
      return {
        [`modal--theme-${this.theme}`]: !!this.theme,
        [`modal--size-${this.size}`]: !!this.size
      }
    },
  },

  methods: {
    open() {
      this.opened = true
      this.$options.service.open()
      this.$emit('open', this)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    close() {
      this.opened = false
      this.$options.service.close()
      this.$emit('close', this)
      this.resolve(this)
    },

    dismiss() {
      this.close()
      this.$emit('dismiss', this)
    },

    resolve() {},
    reject() {}
  }
}

</script>


// WEBPACK FOOTER //
// src/js/shared/components/modal/modal.vue